import React from "react";

function SpouseDoBQuestion(props) {
  function getDoB(type) {
    let text = "Spouse_DOB_" + type;
    return props.getAnswer(text, 0);
  }
  function getAge() {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    var DOBdd = 0;
    var DOBmm = 0;
    var DOByyyy = 0;

    if (getDoB("Month") && getDoB("Day") && getDoB("Year")) {
      DOBdd = getDoB("Day");
      DOBmm = getDoB("Month");
      DOByyyy = getDoB("Year");
    } else {
      return "";
    }
    var ageThisYear = yyyy - DOByyyy - 1;
    if (DOBmm < mm) {
      ageThisYear += 1;
    } else {
      if (DOBmm === mm) {
        if (DOBdd <= dd) {
          ageThisYear += 1;
        }
      }
    }
    return ageThisYear;
  }

  return (
    <li id="Spouse_DoB_li">
      <label className="description" htmlFor="Spouse_DOB">
        {props.QuestionText}
      </label>
      <span>
        <input
          id="Spouse_DOB_Month"
          name="Spouse_DOB_Month"
          className="element text"
          size="2"
          maxLength="2"
          type="text"
          defaultValue={getDoB("Month")}
          onBlur={(event) => {
            // console.log("test", event);
            props.handleValue(event);
            // console.log("value handled");
          }}
          required
        />
        /<label htmlFor="Spouse_DOB_Month">MM</label>
      </span>
      <span>
        <input
          id="Spouse_DOB_Day"
          name="Spouse_DOB_Day"
          className="element text"
          size="2"
          maxLength="2"
          type="text"
          defaultValue={getDoB("Day")}
          onBlur={(event) => {
            props.handleValue(event);
          }}
          required
        />
        /<label htmlFor="Spouse_DOB_Day">DD</label>
      </span>
      <span>
        <input
          id="Spouse_DOB_Year"
          name="Spouse_DOB_Year"
          defaultValue={getDoB("Year")}
          className="element text"
          size="4"
          maxLength="4"
          type="text"
          onBlur={(event) => {
            props.handleValue(event);
          }}
          required
        />
        <label htmlFor="Spouse_DOB_Year">YYYY</label>
      </span>
      <span>{getAge() === "" ? "" : "Age:" + getAge()}</span>
    </li>
  );
}

export default SpouseDoBQuestion;
